<template>
  <el-dialog
    :title="$t('printerMachine.edit')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <el-form
      ref="form"
      :model="editPrinterMachineInfo"
      label-width="120px"
      label-position="left"
    >
      <el-form-item
        :label="$t('printerMachine.machineCode')"
        prop="machineCode"
        :rules="[
          { required: true, message: $t('printerMachine.machineCodeRequired'), trigger: 'blur' },
          { max: 64, message: $t('printerMachine.maxLength64'), trigger: 'blur' }
        ]"
      >
        <el-input
          v-model="editPrinterMachineInfo.machineCode"
          :placeholder="$t('printerMachine.machineCodePlaceholder')"
          style="width: 100%"
        ></el-input>
      </el-form-item>

      <el-form-item
        :label="$t('printerMachine.machineType')"
        prop="machineType"
        :rules="[
          { required: true, message: $t('printerMachine.machineTypeRequired'), trigger: 'change' },
          { max: 64, message: $t('printerMachine.maxLength64'), trigger: 'blur' }
        ]"
      >
        <el-select
          v-model="editPrinterMachineInfo.machineType"
          :placeholder="$t('printerMachine.machineTypePlaceholder')"
          style="width: 100%"
        >
          <el-option
            :label="$t('printerMachine.orderPrinter')"
            value="ORDER"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        :label="$t('printerMachine.appId')"
        prop="appId"
        :rules="[
          { required: true, message: $t('printerMachine.appIdRequired'), trigger: 'blur' },
          { max: 64, message: $t('printerMachine.maxLength64'), trigger: 'blur' }
        ]"
      >
        <el-input
          v-model="editPrinterMachineInfo.appId"
          :placeholder="$t('printerMachine.appIdPlaceholder')"
          style="width: 100%"
        ></el-input>
      </el-form-item>

      <el-form-item
        :label="$t('printerMachine.appSecure')"
        prop="appSecure"
        :rules="[
          { required: true, message: $t('printerMachine.appSecureRequired'), trigger: 'blur' },
          { max: 64, message: $t('printerMachine.maxLength64'), trigger: 'blur' }
        ]"
      >
        <el-input
          v-model="editPrinterMachineInfo.appSecure"
          :placeholder="$t('printerMachine.appSecurePlaceholder')"
          style="width: 100%"
        ></el-input>
      </el-form-item>

      <el-form-item
        :label="$t('printerMachine.machineImpl')"
        prop="machineImpl"
        :rules="[
          { required: true, message: $t('printerMachine.machineImplRequired'), trigger: 'change' }
        ]"
      >
        <el-select
          v-model="editPrinterMachineInfo.machineImpl"
          :placeholder="$t('printerMachine.machineImplPlaceholder')"
          style="width: 100%"
        >
          <el-option
            :label="$t('printerMachine.yilanyun')"
            value="yilanyunOrderPrintAdapter"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="editPrinterMachine">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateShopPrinterMachine } from '@/api/shop/printerMachineApi'

export default {
  name: 'EditPrinterMachine',
  data() {
    return {
      dialogVisible: false,
      editPrinterMachineInfo: {
        machineId: '',
        machineCode: '',
        machineType: '',
        appId: '',
        appSecure: '',
        shopId: '',
        machineImpl: ''
      }
    }
  },
  methods: {
    open(params) {
      this.editPrinterMachineInfo = Object.assign({}, params)
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    async editPrinterMachine() {
      try {
        await this.$refs.form.validate()
        await updateShopPrinterMachine(this.editPrinterMachineInfo)
        this.$message.success(this.$t('printerMachine.updateSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('更新失败:', error)
      }
    }
  }
}
</script>